import { render, staticRenderFns } from "./bdmResources.vue?vue&type=template&id=4ccf9886&scoped=true&"
import script from "./bdmResources.vue?vue&type=script&lang=js&"
export * from "./bdmResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf9886",
  null
  
)

export default component.exports